
const DashboardIcon = () => {

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink: 0}}>
    <path d="M13.4058 13.4058C12.4783 14.3333 10.9856 14.3333 8 14.3333C5.01444 14.3333 3.52166 14.3333 2.59416 13.4058C1.66667 12.4783 1.66667 10.9855 1.66667 7.99992C1.66667 5.01436 1.66667 3.52157 2.59416 2.59408C3.52166 1.66658 5.01444 1.66658 8 1.66658C10.9856 1.66659 12.4783 1.66659 13.4058 2.59408C14.3333 3.52158 14.3333 5.01436 14.3333 7.99992C14.3333 10.9855 14.3333 12.4783 13.4058 13.4058Z" stroke="#141B34" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 14.3333L6 1.66659" stroke="#141B34" stroke-width="1.5"/>
    </svg>
  );
};

export default DashboardIcon;
